const LOCALE = "en-US";

const currencyFormatter = (currency: string) =>
  new Intl.NumberFormat(LOCALE, {
    currency: currency.toUpperCase(),
    style: "currency"
  });

export const getCurrencyCode = (currency: string) => currency.toUpperCase();

// Hermes lacks Intl.NumberFormat#formatToParts
export const getCurrencySymbol = (currency: string): string =>
  currencyFormatter(currency)
    .format(0)
    .replace(/[\d.,\s]/g, "") || getCurrencyCode(currency);

export const formatCurrency = (value: number, currency: string) =>
  currencyFormatter(currency).format(value);
